import { isEmpty } from 'lodash';

export function maxLength(max: number, customMessage?: (value: any, max: number) => string) {
  return (value: any) => {
    if (!isEmpty(value) && value.length > max) {
      if (customMessage) {
        return customMessage(value, max);
      }
      return `Must be no more than ${max} characters`;
    }
    return false;
  };
}
